import { Expose, plainToInstance, Type } from "class-transformer";
import {
  IsDate,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  ValidateNested,
} from "class-validator";
import { AccountManager } from "../account-manager";
import { OnboardingStep } from "../onboarding-step";
import { DesignProjectOnboardingBudget } from "../onboarding-step/design-project-onboarding-budget.entity";
import { PackageType, Product } from "./product.entity";

export class DesignProject {
  public static from(designProject: DesignProject) {
    return plainToInstance(DesignProject, designProject, {
      excludeExtraneousValues: true,
    });
  }

  @Expose()
  @IsString()
  @IsNotEmpty()
  id!: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  accountId!: string;

  @Expose()
  @IsOptional()
  designProjectOnboardingStep?: OnboardingStep[];

  @Expose()
  @IsOptional()
  @ValidateNested()
  @Type(() => AccountManager)
  accountManager?: AccountManager | null;

  @Expose()
  @IsOptional()
  @ValidateNested()
  @Type(() => DesignProjectOnboardingBudget)
  designProjectOnboardingBudget?: DesignProjectOnboardingBudget | null;

  @Expose()
  @IsDate()
  createdTs!: Date;

  @Expose()
  @IsDate()
  updatedTs!: Date;

  @Expose()
  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => Product)
  accountPurchasedProducts?: Product[];

  @Expose()
  @IsOptional()
  parcelSizeAcres?: number | null;

  @Expose()
  @IsOptional()
  parcelSizeConfirmed?: boolean;

  @Expose()
  @IsOptional()
  zillowHomePrice?: number | null;

  @Expose()
  @IsOptional()
  zillowZestimate?: number | null;

  @Expose()
  @IsOptional()
  zillowHomeSf?: number | null;

  @Expose()
  @IsOptional()
  @IsEnum(PackageType)
  packageType?: PackageType | null;
}
